import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LaunchIcon from '@mui/icons-material/Launch';

const APP_STORE_URL = 'https://apps.apple.com/br/app/washpass/id6503068980';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=washpass.app&hl=pt_BR';

interface Props {
  open: boolean;
  partnerName: string;
  serviceName: string;
  serviceId: number | null;
  carwashId: number | null;
  onClose: () => void;
}

function ContractServiceDialog({ open, partnerName, serviceName, serviceId, carwashId, onClose }: Props) {
  function handleOpenApp() {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
    const isAndroid = /android/i.test(userAgent);

    if (!isIOS && !isAndroid) {
      window.location.href = '/app-download';
      return;
    }

    const hasValidIds = serviceId != null && carwashId != null;
    const deepLinkPath = hasValidIds
      ? `additional-service?serviceId=${serviceId}&carwashId=${carwashId}`
      : '';

    const appUrl = isIOS
      ? `washpass://${deepLinkPath}`
      : `intent://${deepLinkPath}#Intent;scheme=washpass;package=washpass.app;end`;
    const fallbackUrl = isIOS ? APP_STORE_URL : PLAY_STORE_URL;

    let appOpened = false;
    const timeoutRef: { current: ReturnType<typeof setTimeout> | null } = { current: null };

    const handleBlur = () => {
      appOpened = true;
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      window.removeEventListener('blur', handleBlur);
    };

    window.addEventListener('blur', handleBlur);
    window.location.href = appUrl;

    timeoutRef.current = setTimeout(() => {
      if (!appOpened) {
        window.removeEventListener('blur', handleBlur);
        window.location.href = fallbackUrl;
      }
    }, 2000);
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ pr: 6 }}>
        Contratar serviço
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ position: 'absolute', top: 8, right: 8 }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Stack spacing={2.5} alignItems="center" sx={{ py: 1 }}>
          <Box
            sx={{
              bgcolor: '#e0f7ff',
              borderRadius: 3,
              px: 3,
              py: 2,
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography variant="subtitle2" fontWeight={700} color="#00b4e4">
              {serviceName}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {partnerName}
            </Typography>
          </Box>

          <Typography variant="body2" textAlign="center" color="text.secondary">
            Para contratar este serviço, acesse o aplicativo WashPass. A contratação é feita
            diretamente no app com segurança e praticidade.
          </Typography>

          <Button
            variant="contained"
            fullWidth
            startIcon={<LaunchIcon />}
            onClick={handleOpenApp}
            sx={{
              bgcolor: '#00b4e4',
              '&:hover': { bgcolor: '#0099c6' },
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: 2,
            }}
          >
            Acessar no app
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default ContractServiceDialog;
